<template>
  <layout-bigscreen nav_top="0">
    <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" style="width:100%; height:100%;">
      <div class="antdVue">

        <div
          class="flex flex-direction flex-wrap align-stretch benben-flex-layout gongzuotaita_368_random_flex_0 w-100 bg-size-auto">
          <div class="flex flex-wrap align-stretch justify-between  w-100">
            <div
              class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_737_fd0_0_c0 bg-c-fff mg-t-0 mg-r-10 mg-b-0 mg-l-0 w-100 bg-size-auto">
              <div class="flex  flex-wrap align-center gongzuotaita_508_fd0_0_c0_c0 w-100 t-22 t-w-6">
                <span>经营数据</span>

              </div>
              <div class="flex flex-wrap align-center justify-between  w-100">
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>支付金额</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{payAmount.price}}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{payAmount.today}}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{payAmount.yesterday}}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>支付订单数</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{ payOrderCount.price }}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ payOrderCount.today }}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ payOrderCount.yesterday }}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>支付用户数</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{ payUserCount.price }}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ payUserCount.today }}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ payUserCount.yesterday }}</span>

                      </div>

                    </div>

                  </div>

                </div>

              </div>
              <div class="flex flex-wrap align-center justify-between gongzuotaita_307_fd0_0_c0_c2 w-100">
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>转化率</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{zhuanHua.price}}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{zhuanHua.today}}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{zhuanHua.yesterday}}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>客单价</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{ customerPrice.price }}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ customerPrice.today }}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ customerPrice.yesterday }}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_265_fd0_0_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>单均价</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{jundan.price}}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{jundan.today}}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{jundan.yesterday}}</span>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>
            <div
              class="flex align-stretch justify-between flex-sub gongzuotaita_638_fd0_0_c1 bg-c-fff w-100 bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">新增用户</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-line-simple class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                                      :field-options="userAxis" data_source_type="1" chart_show_type="line-simple"
                                      show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_7895"
                                      :chart-option="chartOptions_random_5472">

                  </benben-line-simple>


                </div>

              </div>
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">转化率/客单价</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-line-match-bar class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                                         :field-options="customerPriceList" data_source_type="1" chart_show_type="line-match-bar"
                                         show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_5690"
                                         :chart-option="chartOptions_random_1253">

                  </benben-line-match-bar>


                </div>

              </div>

            </div>

          </div>
          <div class="flex align-stretch flex-sub gongzuotaita_307_fd0_0_c0_c2 w-100">
            <div
              class="flex flex-direction flex-wrap align-stretch gongzuotaita_803_fd0_1_c0 bg-c-fff mg-t-0 mg-r-10 mg-b-0 mg-l-0 bg-size-auto">
              <div class="flex  flex-wrap align-center gongzuotaita_508_fd0_0_c0_c0 w-100 t-22 t-w-6">
                <span>财务</span>

              </div>
              <div class="flex flex-wrap align-center justify-between  w-100">
                <div class="flex  flex-wrap align-center gongzuotaita_976_fd0_1_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>自营毛利</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{baoli.price}}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{baoli.today}}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{baoli.yesterday}}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_976_fd0_1_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>自营毛利率</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{maolv.price}}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{maolv.today}}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{maolv.yesterday}}</span>

                      </div>

                    </div>

                  </div>

                </div>

              </div>
              <div class="flex flex-wrap align-center justify-between gongzuotaita_307_fd0_0_c0_c2 w-100">
                <div class="flex  flex-wrap align-center gongzuotaita_976_fd0_1_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>退款金额</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{ refundAmount.price }}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ refundAmount.today }}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ refundAmount.yesterday }}</span>

                      </div>

                    </div>

                  </div>

                </div>
                <div class="flex  flex-wrap align-center gongzuotaita_976_fd0_1_c0_c1_c0 bg-size-auto">
                  <div class="flex  flex-wrap align-center  w-100 t-16 t-w-5">
                    <span>退款单数</span>

                  </div>
                  <div class="flex align-end  w-100">
                    <div class="flex  flex-wrap align-center">
                      <span class="t-w-6 t-14">{{ refundCount.price }}</span>

                    </div>
                    <div class="flex  flex-wrap align-center  mg-t-0 mg-r-0 mg-b-0 mg-l-10">
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">今日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ refundCount.today }}</span>

                      </div>
                      <div class="flex align-center  w-100">
                        <span class="t-w-5">昨日</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">↑</span>
                        <span class="gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1">{{ refundCount.yesterday }}</span>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>
            <div
              class="flex flex-wrap align-stretch justify-between flex-sub gongzuotaita_638_fd0_0_c1 bg-c-fff w-100 bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">流量趋势图</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-line-simple class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                                      :field-options="goodsBrowseChart" data_source_type="1" chart_show_type="line-simple"
                                      show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_3411"
                                      :chart-option="chartOptions_random_3986">

                  </benben-line-simple>


                </div>

              </div>

            </div>

          </div>
          <div class="flex flex-wrap align-stretch justify-between gongzuotaita_307_fd0_0_c0_c2 w-100">
            <div class="flex flex-wrap align-stretch justify-between gongzuotaita_190_fd0_2_c0 bg-c-fff bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">AARRR漏斗</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-other-funnel class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                    :field-options="field_options_262766" data_source_type="1" chart_show_type="other-funnel"
                    title_position="left" title_name="标题" show_title="false" :theme_color="theme_color_7528"
                    :chart-option="chartOptions_random_9953">

                  </benben-other-funnel>


                </div>

              </div>

            </div>
            <div class="flex flex-wrap align-stretch justify-between gongzuotaita_190_fd0_2_c0 bg-c-fff bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">类目销售饼状图</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-pie-ring class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                                   :field-options="cateAmountChart" data_source_type="1" chart_show_type="pie-ring" :theme_color="theme_color_7157"
                                   show_title="false" title_position="left" title_name="标题" :chart-option="chartOptions_random_5603">

                  </benben-pie-ring>


                </div>

              </div>

            </div>
            <div class="flex flex-wrap align-stretch justify-between gongzuotaita_344_fd0_2_c2 bg-c-fff bg-size-auto">
              <div class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_508_fd0_0_c0_c0 t-22 t-w-6">
                <span class="gongzuotaita_692_fd0_0_c1_c0_c0">订单趋势图</span>
                <div class="flex flex-wrap align-center flex-sub  w-100">

                  <benben-line-simple class='gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 w-100'
                                      :field-options="orderAmoutChart" data_source_type="1" chart_show_type="line-simple"
                                      show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_6980"
                                      :chart-option="chartOptions_random_5066">

                  </benben-line-simple>


                </div>

              </div>

            </div>

          </div>
          <div class="flex flex-wrap align-stretch justify-between gongzuotaita_307_fd0_0_c0_c2 w-100">
            <div
              class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_737_fd0_0_c0 bg-c-fff mg-t-0 mg-r-10 mg-b-0 mg-l-0 w-100 bg-size-auto">
              <div class="flex  flex-wrap align-center gongzuotaita_508_fd0_0_c0_c0 w-100 t-22 t-w-6">
                <span>商品销量排行</span>

              </div>
              <div class="flex flex-wrap align-center flex-sub  w-100">

                <big-screen-custom-table class='gongzuotaita_943_random_fd0_3_c0_c1_c0 t-ct t-14'
                                         :field-options="goodsSalesList" data_source_type="1" chart_show_type="big_screen_table"
                                         :new_width="true" width="100%" height="100%" :show_num="10" sort_order="desc" sort_field="num"
                                         sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_2770"
                                         play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="10"
                                         :column_config="[]">
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                  </div>
                  <template v-slot:other="{index}">
                    <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                      <div class="flex flex justify-center align-center">
                        <span>{{index}}</span>

                      </div>

                    </div>
                  </template>

                </big-screen-custom-table>


              </div>

            </div>
            <div
              class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_737_fd0_0_c0 bg-c-fff w-100 bg-size-auto">
              <div class="flex  flex-wrap align-center gongzuotaita_508_fd0_0_c0_c0 w-100 t-22 t-w-6">
                <span>加入购物车排行榜</span>

              </div>
              <div class="flex flex-wrap align-center flex-sub  w-100">

                <big-screen-custom-table class='gongzuotaita_943_random_fd0_3_c0_c1_c0 t-ct t-14'
                                         :field-options="goodsCartRank" data_source_type="1" chart_show_type="big_screen_table"
                                         :new_width="true" width="100%" height="100%" :show_num="10" sort_order="desc" sort_field="num"
                                         sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_4842"
                                         play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="10"
                                         :column_config="[]">
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                  </div>
                  <template v-slot:other="{index}">
                    <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                      <div class="flex flex justify-center align-center">
                        <span>{{index}}</span>

                      </div>

                    </div>
                  </template>

                </big-screen-custom-table>


              </div>

            </div>

          </div>
<!--          <div class="flex  flex-wrap align-center gongzuotaita_307_fd0_0_c0_c2 w-100">
            <div
              class="flex flex-direction flex-wrap align-stretch flex-sub gongzuotaita_737_fd0_0_c0 bg-c-fff w-100 bg-size-auto">
              <div class="flex  flex-wrap align-center gongzuotaita_508_fd0_0_c0_c0 w-100 t-22 t-w-6">
                <span>国家销量排行榜</span>

              </div>
              <div class="flex flex-wrap align-center flex-sub  w-100">

                <big-screen-custom-table class='gongzuotaita_943_random_fd0_3_c0_c1_c0 t-ct t-14'
                  :field-options="field_options_260836" data_source_type="1" chart_show_type="big_screen_table"
                  :new_width="true" width="100%" height="100%" :show_num="10" sort_order="desc" sort_field="num"
                  sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_1389"
                  play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="10"
                  :column_config="[]">
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                  </div>
                  <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                    <img class='gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0'
                      src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                  </div>
                  <template v-slot:other="{index}">
                    <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                      <div class="flex flex justify-center align-center">
                        <span>{{index}}</span>

                      </div>

                    </div>
                  </template>

                </big-screen-custom-table>


              </div>

            </div>

          </div>-->

        </div>

      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
  import {
    bigScreenMixins,
    receiveNew
  } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
  import {
    receive,
    benbenSelectDiy,
    benbenFlexNumberBox,
    scrollList,
    treeSelect,
    simpleSelect,
    multipleSelect,
    cascaderForm,
    checkboxForm,
    switchForm,
    messageReply,
    rangePicker,
    handSignature,
    mixinAddTableItem,
    editorForm,
    qiunDataCharts,
    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    getUrlKey,
    clearDataPass,
    isEmpty,
    treeEdit
  } from '@/assets/diypaaspc/diy-pass-pc.js'
  import {
    provinceForm
  } from '@/assets/diypaaspc/province_area.js'
  import request from '@/utils/request'
  import * as echarts from 'echarts'
  import 'echarts-gl'
  import 'echarts-liquidfill'
  import {
    mapdata
  } from '@/assets/diypaaspc/mapdata.js'
  import layoutBigscreen from "@/components/layoutBigscreen"
  import {homeAllResult, homeResult} from "@/api/statistics/home";
  import {goodsBrowse, goodsCart, goodsCateAmountPie, goodsSalesPage} from "@/api/statistics/goods";
  import {orderAmountChart} from "@/api/statistics/order";
  import {userAxis} from "@/api/statistics/user";
  import moment from 'moment';

  export default {
    name: 'gongzuotaita',
    components: {
      layoutBigscreen
    },
    mixins: [bigScreenMixins],
    data() {
      const themeColorConfig = {
        "presetApi": {
          "getClassifyOne": "",
          "getClassifyTow": "",
          "getClassifyShop": ""
        },
        "themeType": 0,
        "themeConfig": [{
          "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777",
            "#F2CC98", "#F2CC66"
          ],
          "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE",
            "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)",
            "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)",
            "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"
          ],
          "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999",
            "#dddddd", "#1178F0", "#F02325"
          ]
        }]
      };
      receive(this);
      receiveNew(this);
      return {
        themeColorConfig,
        mapdata: mapdata,
        "current_index": "0",
        "iframe_list": [],
        "Timer": {},
        "total": 1,
        "isFullScreen": false,
        "big_screen_global_query": {
          "screen_global_time_range_type": "5",
          "screen_global_time_custom_time": "",
          "screen_global_dept": "",
          "screen_global_user": "",
          "diy_api_time": ""
        },
        "saizhuge_api_loaded": false,
        payAmount: {
          "price": "", // 价格
          "today": "", // 今日
          "yesterday": "" // 昨日
        }, // 支付金额
        "payOrderCount": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 支付订单数
        payUserCount: {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 支付用户数
        "zhuanHua": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 转化率
        customerPrice: {
          "price": "",
          "today": "",
          "yesterday": ""
        },
        "jundan": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 单均价
        "baoli": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 自营毛利
        "maolv": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 自营毛利率
        "refundAmount": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 退款金额
        "refundCount": {
          "price": "",
          "today": "",
          "yesterday": ""
        }, // 退款单数
        "viewSource": "PC",
        "big_screen_global_config": {
          "is_screen_global_time": false,
          "is_screen_global_dept": false,
          "is_screen_global_user": false
        },
        "theme_color_1389": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        "field_options_260836": {
          "columns": [{
            "name": "国家",
            "prop": "subsys"
          }, {
            "name": "销售单数",
            "prop": "module"
          }, {
            "name": "销售件数",
            "prop": "shopnum"
          }, {
            "name": "销售金额",
            "prop": "shopprice"
          }],
          "rows": [{
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }, {
            "subsys": "中国",
            "module": 10,
            "shopnum": 19,
            "shopprice": 120
          }]
        }, // 国家销量排行榜
        "theme_color_4842": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        goodsCartRank: {
          "columns": [{
            "name": "商品名称",
            "prop": "subsys"
          }, {
            "name": "加购数量",
            "prop": "module"
          }],
          "rows": [{
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }]
        }, // 加入购物车排行榜
        "theme_color_2770": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        goodsSalesList: {
          "columns": [{
            "name": "商品名称",
            "prop": "subsys"
          }, {
            "name": "访问次数",
            "prop": "module"
          }],
          "rows": [{
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }, {
            "subsys": "苹果手机",
            "module": 10
          }]
        }, // 商品访问排行
        "theme_color_6980": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_5066": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        orderAmoutChart: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "订单数量",
            "data": [19, 57, 46, 80, 27],
            "type": "line"
          }]
        }, // 订单趋势图
        "chartOptions_random_5603": {
          "seriesSetting": {
            "center": ["50%", "50%"],
            "radius": ["30%", "50%"],
            "itemStyle": {
              "borderColor": "",
              "borderWidth": "",
              "borderRadius": ""
            },
            "startAngle": "",
            "type": "pie",
            "label": {
              "color": "#fff"
            }
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "show": true,
              "emphasis": {
                "show": true,
                "textStyle": {
                  "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect",
            "format": "{b}"
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          }
        },
        "theme_color_7157": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
        cateAmountChart: {
          "series": [{
            "data": [{
              "value": 1335,
              "name": "首饰"
            }, {
              "value": 1310,
              "name": "耳饰"
            }, {
              "value": 1234,
              "name": "手链"
            }, {
              "value": 1350,
              "name": "装修"
            }, {
              "value": 1548,
              "name": "14k金"
            }]
          }]
        }, // 类目销售饼状图
        "theme_color_7528": ["rgba(104, 148, 252, 1)", "rgba(81, 204, 251, 1)", "rgba(47, 211, 165, 1)",
          "rgba(255, 104, 83, 1)", "rgba(253, 157, 54, 1)", "#6AE7E6", "#0F36A2", "#FC658A"
        ],
        "chartOptions_random_9953": {
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "#fff"
            },
            "show": false,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "labelSetting": {
            "label": {
              "color": "rgba(10, 10, 36, 1)",
              "position": "center",
                 "fontSize": 12,
                 "show": true,
                 "formatter": "{b}\n{c}",
                 "emphasis": {
                   "show": true,
                   "textStyle": {
                     "fontSize": 14,
                  "color": "#fff"
                },
                "rich": {
                  "a": {
                    "fontSize": 14
                  }
                }
              }
            },
            "labelLine": {
              "show": true
            }
          },
          "tooltip": {
            "show": true,
            "autoToolTip": false,
            "trigger": "item",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "seriesSetting": {
            "left": "auto",
            "top": "10%"
          }
        },
        "field_options_262766": {
          "series": [{
            "name": "",
            "type": "funnel",
            "width": "60%",
            "height": "80%",
            "left": "20%",
            "data": [{
              "value": 60,
              "name": "拉新用户:"
            }, {
              "value": 40,
              "name": "新订单:"
            }, {
              "value": 20,
              "name": "留存用户:"
            }, {
              "value": 80,
              "name": "复购订单:"
            }, {
              "value": 100,
              "name": "裂变访问"
            }]
          }]
        }, // AARRR漏斗
        "theme_color_3411": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_3986": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        goodsBrowseChart: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "PV",
            "data": [19, 57, 46, 80, 27],
            "type": "line"
          }, {
            "name": "UV",
            "data": [69, 27, 42, 32, 47],
            "type": "line"
          }]
        }, // 流量趋势图
        "theme_color_5690": ["rgba(92, 134, 229, 1)", "rgba(106, 188, 197, 1)", "#F8A200", "#B0D630", "#6EC890",
          "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"
        ],
        "chartOptions_random_1253": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "backgroundColor": "rgba(50,50,50,0.7)",
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            },
            "show": false
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": "",
            "symbol_icon": "roundRect",
            "icon": "roundRect"
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": [{
            "type": "value",
            "name": "存储使用量",
            "position": "left",
            "alignTicks": true,
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "formatter": "{value} ",
              "color": "rgba(10, 10, 36, 1)"
            },
            "splitLine": {
              "show": false
            }
          }, {
            "type": "value",
            "name": "用户活跃度",
            "position": "right",
            "alignTicks": true,
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "formatter": "{value}",
              "color": "rgba(10, 10, 36, 1)"
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          }],
          "barSetting": {
            "barWidth": 10,
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "label": {
                "color": "#fff"
              },
              "symbol": "none",
              "lineStyle": {
                "type": "dashed"
              },
              "data": []
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            }
          }
        },
        customerPriceList: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [/*{
            "name": "转化率",
            "type": "bar",
            "yAxisIndex": 1,
            "barWidth": 10,
            "itemStyle": {
              "borderRadius": [5, 5, 5, 5]
            },
            "data": [2500, 2900, 3200, 3600, 4100, 4800, 5500]
          },*/ {
            "name": "客单价",
            "type": "line",
            "yAxisIndex": 0,
            "data": [50, 55, 60, 65, 70, 75, 80]
          }]
        }, // 转化率/客单价
        "theme_color_7895": ["rgba(92, 134, 229, 1)", "#0F36A2", "rgba(45, 60, 152, 1)", "#F27B60", "#F8A200",
          "#B0D630", "#6EC890", "#6AE7E6", "#FC658A"
        ],
        "chartOptions_random_5472": {
          "tooltip": {
            "trigger": "axis",
            "axisPointer": {
              "type": "shadow"
            },
            "textStyle": {
              "color": "inherit",
              "fontSize": 14
            }
          },
          "legend": {
            "type": "scroll",
            "textStyle": {
              "color": "rgba(10, 10, 36, 1)"
            },
            "show": true,
            "orient": "horizontal",
            "left": "center",
            "top": ""
          },
          "grid": {
            "left": "1%",
            "right": "2%",
            "bottom": "0%",
            "top": "15%",
            "containLabel": true
          },
          "xAxis": {
            "type": "category",
            "axisTick": {
              "show": true
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400,
              "rotate": 0
            },
            "splitLine": {
              "show": false,
              "lineStyle": {
                "color": "rgba(10, 10, 36, 1)"
              }
            }
          },
          "yAxis": {
            "type": "value",
            "axisTick": {
              "show": false
            },
            "axisLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            },
            "axisLabel": {
              "show": true,
              "color": "rgba(10, 10, 36, 1)",
              "fontSize": 12,
              "fontWeight": 400
            },
            "splitLine": {
              "show": true,
              "lineStyle": {
                "color": "rgba(238, 238, 238, 1)"
              }
            }
          },
          "seriesSetting": {
            "markPoint": {
              "label": {
                "normal": {
                  "textStyle": {
                    "color": "#fff",
                    "fontSize": 14,
                    "fontWeight": 400
                  }
                }
              },
              "itemStyle": [],
              "data": [],
              "symbol": "pin",
              "symbolSize": 50
            },
            "markLine": {
              "data": [],
              "lineStyle": {
                "type": "dashed"
              },
              "label": {
                "color": "#fff"
              },
              "symbol": "none"
            },
            "label": {
              "normal": {
                "show": false,
                "position": "top",
                "fontSize": 14,
                "color": "inherit"
              }
            },
            "smooth": true,
            "symbol_icon": "roundRect",
            "symbol": "roundRect",
            "showAllSymbol": true,
            "symbolSize": [10, 10]
          }
        },
        userAxis: {
          "xAxis": {
            "data": ["2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20", "2026-01-20"]
          },
          "series": [{
            "name": "新增用户",
            "data": [19, 57, 46, 80, 27],
            "type": "line"
          }]
        } // 新增用户
      };

    },
    filters: {},
    created() {
      if (getUrlKey('viewSource')) {
        this.viewSource = getUrlKey('viewSource');
      }
      //this.get_url_list()
      //查询数据
      this.getHomeStatistics()

      this.getGoodsCartRank()
      this.getGoodsSalesPage()
      this.getOrderAmountChart()
      this.getUserAxis()
      this.getCateAmountPie()
      this.getGoodsBrowseChart()
    },
    mounted() {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      moment,
      copyText,
      mixinTableItemChange,
      in_array,
      themeColorInit,
      isEmpty,
      //自动轮播展示页面
      change_page() {
        var that = this;
        that.Timer = setInterval(function() {
          that.$refs['iframeBox_' + that.current_index][0].contentWindow.postMessage({
            ident: 'open_mute',
            open: false
          }, '*')
          that.current_index = (that.current_index + 1) % that.iframe_list.length;
          console.log(that.current_index, 'that.current_index')
          that.$refs['iframeBox_' + that.current_index][0].contentWindow.postMessage({
            ident: 'open_mute',
            open: true
          }, '*')
          that.total += 1;
        }, 10000)
      },
      //获取轮播页面列表
      get_url_list() {
        this.iframe_list = []
        //this.iframe_list =[{"url":" /spread/general/index?view_name=shujuzichanjiankongjiashicang","dapingzhuti":"领导驾驶舱"},
        //{"url":" /spread/general/index?view_name=jiaoxuegaikuangjiashicang","dapingzhuti":"教学概况驾驶舱"}];

        this.change_page()
      },
      //清除轮播计时器
      clearTimerFunc() {
        if (this.Timer) {
          clearInterval(this.Timer)
          this.Timer = null
        }
      },
      //统一获取自定义接口
      get_diy_api_page() {

      },
      getHomeStatistics() {
        homeAllResult({}).then(response => {
          this.payAmount.price =  response.data.payAmount
          this.payUserCount.price =  response.data.payUserCount
          this.payOrderCount.price =  response.data.payOrderCount
          //转化率 = payUserCount /userCount
          const avg = response.data.userCount === 0 ? 0 : (response.data.payUserCount / response.data.userCount) * 100
          this.zhuanHua.price = avg.toFixed(2) + "%"
          this.customerPrice.price =  response.data.customerPrice
          this.jundan.price =  response.data.customerPrice
          this.refundCount.price =  response.data.refundCount
          this.refundAmount.price =  response.data.refundAmount


        });
        homeResult({}).then(response => {
          this.payAmount.today =  response.data.today.payAmount
          this.payAmount.yesterday =  response.data.yesterday.payAmount
          this.payOrderCount.today =  response.data.today.payOrderCount
          this.payOrderCount.yesterday =  response.data.yesterday.payOrderCount
          this.payUserCount.today =  response.data.today.payUserCount
          this.payUserCount.yesterday =  response.data.yesterday.payUserCount

          this.customerPrice.today =  response.data.today.customerPrice
          this.customerPrice.yesterday =  response.data.yesterday.customerPrice
          this.jundan.today =  response.data.today.customerPrice
          this.jundan.yesterday =  response.data.yesterday.customerPrice
          const avgToday = response.data.today.userCount === 0 ? 0 : (response.data.today.payUserCount / response.data.today.userCount) * 100
          this.zhuanHua.today = avgToday.toFixed(2) + "%"

          const avgYesterday = response.data.yesterday.userCount === 0 ? 0 : (response.data.yesterday.payUserCount / response.data.yesterday.userCount) * 100
          this.zhuanHua.yesterday = avgYesterday.toFixed(2) + "%"

          this.refundCount.today =  response.data.today.refundCount
          this.refundCount.yesterday =  response.data.yesterday.refundCount
          this.refundAmount.today =  response.data.today.refundAmount
          this.refundAmount.yesterday =  response.data.yesterday.refundAmount
        });
      },

      getGoodsCartRank() {
        let param = {"pageSize":10}
        goodsCart(param).then(response => {
          const rows = response.data.map(item => ({
            // 商品名称
            subsys: item.goodsName,
            // 购买数量
            module: item.cartNum,
          }));
          this.goodsCartRank = {
            columns: [{
              "name": "商品名称",
              "prop": "subsys"
            }, {
              "name": "加购数量",
              "prop": "module"
            }], "rows": rows
          };
        })
      },

      getGoodsSalesPage() {
        let param = {"pageNum":1,"pageSize":10}
        goodsSalesPage(param).then((response) => {
          const rows = response.data.records.map(item => ({
            // 商品名称
            subsys: item.goodsName,
            // 购买数量
            module: item.salesNum,
          }));
          this.goodsSalesList = {
            "columns": [{
              "name": "商品名称",
              "prop": "subsys"
            }, {
              "name": "销量",
              "prop": "module"
            }],
            "rows": rows
          };
        });
      },

      getOrderAmountChart() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: undefined,
          endTime: undefined,
        }
        orderAmountChart(orderAmountParam).then(response => {
          this.orderAmoutChart = {
            "xAxis": {
              data: response.data.xxAxis
            },
            "series": [{
              "name": "订单数量",
              "data": response.data.yyAxis.orderCountList || [],
              "type": "line"
            }]
          }

          this.customerPriceList= {
            "xAxis": {
              data: response.data.xxAxis
            },
            "series": [/*{
            "name": "转化率",
            "type": "bar",
            "yAxisIndex": 1,
            "barWidth": 10,
            "itemStyle": {
              "borderRadius": [5, 5, 5, 5]
            },
            "data": [2500, 2900, 3200, 3600, 4100, 4800, 5500]
          },*/ {
              "name": "客单价",
              "type": "line",
              "yAxisIndex": 0,
              "data": response.data.yyAxis.customerPriceList || [],
            }]
          }
        })

      },
      getUserAxis() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: moment().subtract(5, 'days').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        userAxis(orderAmountParam).then(response => {
          this.userAxis = {
            xAxis: {
              data: response.data.xxAxis
            },
            series: [{
              name: "新增用户",
              data: response.data.yyAxis.userCountList || [],
              type: "line"
            }]
          }
        })
      },

      getCateAmountPie() {
        goodsCateAmountPie().then(response => {
          this.cateAmountChart={"series": [{"data": response.data}] }
        })

      },


      getGoodsBrowseChart() {
        let orderAmountParam = {
          chartType: 'days',
          dateRange: [],
          startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        goodsBrowse(orderAmountParam).then(response => {
          this.goodsBrowseChart = {
            "xAxis": {
              data: response.data.xxAxis
            },
            "series": [{
              "name": "PV",
              data: response.data.yyAxis.pvList || [],
              "type": "line"
            }, {
              "name": "UV",
              data: response.data.yyAxis.uvList || [],
              "type": "line"
            }]
          }

        })

      },

    }
  }
</script>
<style lang="less" scoped>
  @import '../../assets/diypaaspc/diy-pass-big-screen.css';
  @import '../../assets/diypaaspc/library-ant-design-vue.css';

  .antdVue {
    position: relative;
    width: 100%;
    width: 100%;
    height: 100%;
  }

  .zoom_bg_color {
    background: #fff;
  }

  #antdVue .gongzuotaita_368_random_flex_0 {
    background: #eee;
    min-height: 100vh;
    padding: 24px;
  }

  #antdVue .gongzuotaita_205_fd0_3_c0_c1_c0_c0_c0 {
    max-width: 20px;
    max-height: 20px;
  }

  #antdVue .gongzuotaita_943_random_fd0_3_c0_c1_c0 {
    color: rgba(10, 10, 36, 1);
    --header-bg: #EBF4FF;
    --header-text-color: rgba(10, 10, 36, 1);
    --header-text-font-size: 16px;
  }

  #antdVue .gongzuotaita_344_fd0_2_c2 {
    width: 40%;
    padding: 12px;
    border-radius: 16px;
  }

  #antdVue .gongzuotaita_190_fd0_2_c0 {
    width: 29%;
    padding: 12px;
    border-radius: 16px;
  }

  #antdVue .gongzuotaita_976_fd0_1_c0_c1_c0 {
    background: #ECF8FF;
    width: 48%;
    border-radius: 8px;
    padding: 14px;
  }

  #antdVue .gongzuotaita_803_fd0_1_c0 {
    width: 35%;
    border-radius: 16px;
    padding: 12px;
  }

  #antdVue .gongzuotaita_886_random_fd0_0_c1_c0_c1_c0 {
    height: 260px;
  }

  #antdVue .gongzuotaita_692_fd0_0_c1_c0_c0 {
    margin: 0px 0px 8px 0px;
  }

  #antdVue .gongzuotaita_638_fd0_0_c1 {
    padding: 12px;
    border-radius: 16px;
  }

  #antdVue .gongzuotaita_307_fd0_0_c0_c2 {
    margin: 15px 0px 0px 0px;
  }

  #antdVue .gongzuotaita_434_fd0_0_c0_c1_c0_c1_c1_c0_c1 {
    color: rgba(253, 145, 145, 1);
  }

  #antdVue .gongzuotaita_265_fd0_0_c0_c1_c0 {
    background: #ECF8FF;
    width: 32%;
    border-radius: 8px;
    padding: 14px;
  }

  #antdVue .gongzuotaita_508_fd0_0_c0_c0 {
    margin: 0px 0px 12px 0px;
  }

  #antdVue .gongzuotaita_737_fd0_0_c0 {
    border-radius: 16px;
    padding: 12px;
  }

  #antdVue .benben-iframe-box {
    left: 0;
    top: 0;
  }
</style>
